import { React, useEffect, useState } from 'react'
import { Stack, Table, Button, Alert, Modal, Form, Dropdown, InputGroup } from 'react-bootstrap';
import Login from '../Components/Admin/Login';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import Navigation from '../Components/Admin/Navigation';
import { db } from '../utils/firebase'
import { collection, getDocs, doc, updateDoc, setDoc, deleteDoc } from 'firebase/firestore';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { v4 as uuidv4 } from 'uuid';

export default function UkiesAdminTesting(props) {
    const auth = getAuth();
    const functions = getFunctions();
    const [ token, setToken ] = useState(localStorage.getItem('ukies-webinars-accessToken'))
    const [ user, setUser ] = useState(JSON.parse(localStorage.getItem('ukies-webinars-admin')))
    const [ series, setSeries ] = useState([])
    const [ seriesLoading, setSeriesLoading ] = useState(false)
    const [ testUsers, setTestUsers ] = useState([])
    const [ testUsersLoading, setTestUsersLoading ] = useState(false)
    const [ refreshing, setRefreshing ] = useState(false)
    const [ showAlert, setShowAlert ] = useState(false)
    const [ alertMessage, setAlertMessage ] = useState('')
    const [ alertType, setAlertType ] = useState('success')
    const [ showModal, setShowModal ] = useState(false)
    const [ selected, setSelected ] = useState()
    const [ formData, setFormData ] = useState({})
    const [ saving, setSaving ] = useState(false)
    const [ searchValue, setSearchValue ] = useState('')
    const [ searching, setSearching ] = useState(false)
    const [ deleteEnabled, setDeleteEnabled ] = useState(false)

    useEffect(() => {
        // Set page title
        document.title = 'Ukies Admin - Testen';
        
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                console.log('User is signed in');
            } else {
                console.log('User is signed out');
            }
        });

        return () => unsubscribe();
    }, [auth]);

    // Load series from Firebase only if empty
    useEffect(() => {
        const getSeries = async () => {
            if (series.length > 0) return; // Only load if empty
            
            setSeriesLoading(true);
            try {
                const seriesSnapshot = await getDocs(collection(db, 'series'));
                const result = seriesSnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                
                setSeries(result);
            } catch (error) {
                console.error('Error fetching series:', error);
                setShowAlert(true);
                setAlertMessage('Fout bij het ophalen van series.');
                setAlertType('danger');
            } finally {
                setSeriesLoading(false);
            }
        };

        if (series.length === 0) {
            getSeries();
        }
    }, [series.length]);

    // Load testUsers from Firebase only if empty
    useEffect(() => {
        const getTestUsers = async () => {
            if (testUsers.length > 0) return; // Only load if empty
            
            setTestUsersLoading(true);
            try {
                const testUsersSnapshot = await getDocs(collection(db, 'testUsers'));
                const result = testUsersSnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                
                setTestUsers(result);
            } catch (error) {
                console.error('Error fetching test users:', error);
                setShowAlert(true);
                setAlertMessage('Fout bij het ophalen van test users.');
                setAlertType('danger');
            } finally {
                setTestUsersLoading(false);
            }
        };

        if (testUsers.length === 0) {
            getTestUsers();
        }
    }, [testUsers.length]);

    // Auto-hide alert after 5 seconds
    useEffect(() => {
        if (showAlert) {
            const timer = setTimeout(() => {
                setShowAlert(false);
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [showAlert]);

    // Add custom styles for the refresh button
    useEffect(() => {
        const style = document.createElement('style');
        style.textContent = `
            /* Override Bootstrap primary color */
            .btn-primary {
                background-color: #3b4f46 !important;
                border-color: #3b4f46 !important;
            }
            .btn-primary:hover {
                background-color: #2d3d35 !important;
                border-color: #2d3d35 !important;
            }
            .btn-primary:focus, .btn-primary.focus {
                background-color: #2d3d35 !important;
                border-color: #2d3d35 !important;
                box-shadow: 0 0 0 0.2rem rgba(59, 79, 70, 0.5) !important;
            }
            .btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active {
                background-color: #243028 !important;
                border-color: #243028 !important;
            }
            
            /* Refresh button styling */
            .refresh-button:hover:not(:disabled) {
                background-color: #567a70 !important;
                border-color: #567a70 !important;
            }
            
            /* Add button styling with ukies green colors */
            .add-button-green {
                background-color: var(--ukies-light-green) !important;
                border-color: var(--ukies-light-green) !important;
                color: white !important;
            }
            .add-button-green:hover:not(:disabled) {
                background-color: var(--ukies-dark-green) !important;
                border-color: var(--ukies-dark-green) !important;
                color: white !important;
            }
            .add-button-green:focus:not(:disabled) {
                background-color: var(--ukies-dark-green) !important;
                border-color: var(--ukies-dark-green) !important;
                color: white !important;
                box-shadow: 0 0 0 0.2rem rgba(59, 79, 70, 0.25) !important;
            }
            .add-button-green:active:not(:disabled) {
                background-color: var(--ukies-dark-green) !important;
                border-color: var(--ukies-dark-green) !important;
                color: white !important;
            }
            
            .custom-switch-large {
                transform: scale(1.5);
                transform-origin: left center;
            }
            .custom-switch-large .form-check-input:checked {
                background-color: #28a745 !important;
                border-color: #28a745 !important;
            }
            .custom-switch-large .form-check-input:not(:checked) {
                background-color: #dc3545 !important;
                border-color: #dc3545 !important;
            }
            .custom-switch-large .form-check-input:focus {
                box-shadow: none !important;
            }
            .custom-switch-large .form-check-input:checked:focus {
                background-color: #28a745 !important;
                border-color: #28a745 !important;
                box-shadow: none !important;
            }
            .custom-switch-large .form-check-input:not(:checked):focus {
                background-color: #dc3545 !important;
                border-color: #dc3545 !important;
                box-shadow: none !important;
            }
            .custom-switch-large .form-check-label {
                font-size: 0.7rem !important;
            }
            #enabled-switch .form-check-label {
                font-size: 0.7rem !important;
            }
            
            /* Custom dropdown styles */
            .dropdown-menu {
                max-height: 300px;
                overflow-y: auto;
            }
            .dropdown-item:hover {
                background-color: #f8f9fa;
            }
            .dropdown-item.disabled {
                cursor: not-allowed;
                opacity: 0.6;
            }
            .dropdown-item:active {
                background-color: #e9ecef;
            }
            #series-dropdown {
                justify-content: space-between;
                align-items: center;
            }
            #series-dropdown::after {
                margin-left: auto;
            }
            #series-dropdown .flex-grow-1 {
                text-align: left;
            }
            .dropdown-toggle.show {
                border-color: #86b7fe;
                box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
            }
        `;
        document.head.appendChild(style);

        return () => {
            document.head.removeChild(style);
        };
    }, []);

    const handleRowClick = (tu) => {
        console.log('Selected test user:', tu);
        setSelected(tu);
        
        // Convert seriesEnabled to array of UUIDs for multiselect
        const seriesEnabledUuids = tu.seriesEnabled && Array.isArray(tu.seriesEnabled) 
            ? tu.seriesEnabled.map(series => {
                // If it's already a string (UUID), return it
                if (typeof series === 'string') return series;
                // If it's an object, try to get the uuid, id, or name
                return series.uuid || series.id || series.name || '';
            }).filter(Boolean) // Remove empty strings
            : [];

        setFormData({
            uuid: tu.uuid || '',
            name: tu.name || '',
            email: tu.email || '',
            customerId: tu.customerId || '',
            enabled: tu.enabled !== undefined ? tu.enabled : true,
            seriesEnabled: seriesEnabledUuids
        });
        
        setShowModal(true);
    }

    // Handle form input changes
    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    // Handle series checkbox toggle
    const handleSeriesToggle = (seriesUuid, isChecked) => {
        setFormData(prev => {
            const currentSeriesEnabled = prev.seriesEnabled || [];
            
            if (isChecked) {
                // Add series if not already present
                if (!currentSeriesEnabled.includes(seriesUuid)) {
                    return { ...prev, seriesEnabled: [...currentSeriesEnabled, seriesUuid] };
                }
            } else {
                // Remove series if present
                return { ...prev, seriesEnabled: currentSeriesEnabled.filter(uuid => uuid !== seriesUuid) };
            }
            
            return prev;
        });
    };

    // Handle enabled toggle
    const handleEnabledToggle = () => {
        setFormData(prev => ({
            ...prev,
            enabled: !prev.enabled
        }));
    };

    // Handle customer search
    const handleCustomerSearch = async () => {
        if (!searchValue.trim()) {
            setShowAlert(true);
            setAlertMessage('Voer een klantnummer of emailadres in om te zoeken.');
            setAlertType('warning');
            return;
        }

        setSearching(true);
        try {
            const searchCustomer = httpsCallable(functions, 'ukiesSearchCustomer');
            const result = await searchCustomer({identification: searchValue.trim()});
            
            console.log(result)
            if (result.data && result.data.status === 'success') {
                const customerData = result.data.data;
                setFormData(prev => ({
                    ...prev,
                    customerId: customerData.customerId || '',
                    name: customerData.fullname || '',
                    email: customerData.email || ''
                }));
                
                setShowAlert(true);
                setAlertMessage('Klant succesvol gevonden en gegevens ingevuld!');
                setAlertType('success');
            } else {
                setShowAlert(true);
                setAlertMessage('Geen klant gevonden met deze identificatie.');
                setAlertType('warning');
            }
        } catch (error) {
            console.error('Error searching customer:', error);
            setShowAlert(true);
            setAlertMessage('Fout bij het zoeken naar klant. Probeer het opnieuw.');
            setAlertType('danger');
        } finally {
            setSearching(false);
        }
    };

    // Handle form submission
    const handleSave = async () => {
        if (!selected || !selected.id) return;
        
        setSaving(true);
        try {
            const testUserRef = doc(db, 'testUsers', selected.id);
            const updateData = { ...formData };
            
            await updateDoc(testUserRef, updateData);

            // Update local state
            setTestUsers(prev => prev.map(tu => 
                tu.id === selected.id 
                    ? { ...tu, ...updateData }
                    : tu
            ));

            setShowModal(false);
            setSelected(null);
            setDeleteEnabled(false);
            setShowAlert(true);
            setAlertMessage('Test user succesvol bijgewerkt!');
            setAlertType('success');
        } catch (error) {
            console.error('Error updating test user:', error);
            setShowAlert(true);
            setAlertMessage('Fout bij het bijwerken van de test user. Probeer het opnieuw.');
            setAlertType('danger');
        } finally {
            setSaving(false);
        }
    };

    // Handle modal close
    const handleClose = () => {
        setShowModal(false);
        setSelected(null);
        setFormData({});
        setSearchValue('');
        setDeleteEnabled(false);
    };

    // Handle delete test user
    const handleDeleteTestUser = async () => {
        if (!selected || !selected.id) return;
        
        const confirmMessage = `Weet je zeker dat je test user "${selected.name}" wilt verwijderen?\n\nDeze actie kan niet ongedaan worden gemaakt!`;
        
        if (!window.confirm(confirmMessage)) return;
        
        setSaving(true);
        try {
            // Delete from Firestore
            const testUserRef = doc(db, 'testUsers', selected.id);
            await deleteDoc(testUserRef);

            // Update local state by removing the test user
            setTestUsers(prev => prev.filter(tu => tu.id !== selected.id));

            setShowModal(false);
            setSelected(null);
            setDeleteEnabled(false);
            setShowAlert(true);
            setAlertMessage('Test user succesvol verwijderd!');
            setAlertType('success');
        } catch (error) {
            console.error('Error deleting test user:', error);
            setShowAlert(true);
            setAlertMessage('Fout bij het verwijderen van de test user. Probeer het opnieuw.');
            setAlertType('danger');
        } finally {
            setSaving(false);
        }
    };

    // Handle add new test user
    const handleAddNewTestUser = async () => {
        try {
            const newTestUserUuid = uuidv4();
            const newTestUser = {
                uuid: newTestUserUuid,
                name: 'Nieuwe Tester',
                email: '',
                customerId: '',
                enabled: true,
                seriesEnabled: []
            };

            // Add to Firestore
            const testUserRef = doc(db, 'testUsers', newTestUserUuid);
            await setDoc(testUserRef, newTestUser);

            // Add ID for local state
            newTestUser.id = newTestUserUuid;

            // Update local state
            setTestUsers(prev => [...prev, newTestUser]);

            // Open the modal with the new test user
            handleRowClick(newTestUser);

            setShowAlert(true);
            setAlertMessage('Nieuwe tester succesvol aangemaakt!');
            setAlertType('success');
        } catch (error) {
            console.error('Error adding new test user:', error);
            setShowAlert(true);
            setAlertMessage('Fout bij het aanmaken van een nieuwe tester. Probeer het opnieuw.');
            setAlertType('danger');
        }
    };

    // Handle refresh data
    const handleRefreshData = async () => {
        setRefreshing(true);
        try {
            // Refresh series
            const seriesSnapshot = await getDocs(collection(db, 'series'));
            const seriesResult = seriesSnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            setSeries(seriesResult);

            // Refresh testUsers
            const testUsersSnapshot = await getDocs(collection(db, 'testUsers'));
            const testUsersResult = testUsersSnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            setTestUsers(testUsersResult);
            
            setShowAlert(true);
            setAlertMessage('Data succesvol ververst!');
            setAlertType('success');
        } catch (error) {
            console.error('Error refreshing data:', error);
            setShowAlert(true);
            setAlertMessage('Fout bij het verversen van de data. Probeer het opnieuw.');
            setAlertType('danger');
        } finally {
            setRefreshing(false);
        }
    };

    if (!token || !user) {
        return <Login setToken={setToken} setUser={setUser} />;
    }

    return (
        <>
            <Navigation user={user} currentPage="testing" />
            
            {showAlert && (
                <Alert 
                    variant={alertType} 
                    dismissible 
                    onClose={() => setShowAlert(false)} 
                    style={{
                        position: 'fixed',
                        top: '15px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        zIndex: 1060,
                        minWidth: '300px',
                        maxWidth: '600px'
                    }}
                >
                    {alertMessage}
                </Alert>
            )}
            
            <Stack style={{marginTop:'50px',padding:'1rem 0'}}>
                <h1 style={{fontSize:'2.5rem'}}>Testen</h1>
                <Table striped hover style={{cursor:'pointer'}}>
                    <thead>
                        <tr>
                            <th style={{ textAlign: 'center' }}>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 4.5C7.5 4.5 3.75 7.5 1.5 12C3.75 16.5 7.5 19.5 12 19.5C16.5 19.5 20.25 16.5 22.5 12C20.25 7.5 16.5 4.5 12 4.5ZM12 17C9.75 17 7.5 15.75 7.5 12C7.5 8.25 9.75 7 12 7C14.25 7 16.5 8.25 16.5 12C16.5 15.75 14.25 17 12 17ZM12 9C10.5 9 9 10.5 9 12C9 13.5 10.5 15 12 15C13.5 15 15 13.5 15 12C15 10.5 13.5 9 12 9Z" fill="currentColor"/>
                                </svg>
                            </th>
                            <th>Naam</th>
                            <th>Email</th>
                            <th>Klantnummer</th>
                            <th>Testobjecten</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            testUsers.length > 0 &&
                            testUsers.map((tu) => {
                                return(
                                    <tr key={tu.uuid} onClick={() => handleRowClick(tu)}>
                                        <td style={{ textAlign: 'center', color: tu.enabled ? '#28a745' : '#dc3545' }}>
                                            {tu.enabled ? '✓' : '✗'}
                                        </td>
                                        <td>{tu.name}</td>
                                        <td>{tu.email}</td>
                                        <td>{tu.customerId}</td>
                                        <td>{tu.seriesEnabled.length || 0} series</td>
                                    </tr>

                                )
                            })
                        }
                    </tbody>
                </Table>
                
                {/* Action Buttons */}
                <div className="d-flex justify-content-end mt-3 gap-2">
                    <Button 
                        variant="success" 
                        size="sm"
                        onClick={handleAddNewTestUser}
                        disabled={refreshing || testUsersLoading || seriesLoading}
                        title="Klik om een nieuwe test user toe te voegen"
                        className="add-button-green"
                    >
                        + Toevoegen
                    </Button>
                    <Button 
                        variant="primary" 
                        size="sm"
                        onClick={handleRefreshData}
                        disabled={refreshing || testUsersLoading || seriesLoading}
                        title="Klik om data te verversen"
                        className="refresh-button"
                    >
                        {refreshing ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Verversen...
                            </>
                        ) : (
                            <>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-clockwise me-2" viewBox="0 0 16 16">
                                    <path fillRule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
                                    <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
                                </svg>
                                Refresh
                            </>
                        )}
                    </Button>
                </div>
            </Stack>
            
            {/* Edit Test User Modal */}
            <Modal show={showModal} onHide={handleClose} size="lg" backdrop={true} keyboard={true}>
                <Modal.Header closeButton>
                    <div>
                        <Modal.Title>{selected?.name || 'Test User'}</Modal.Title>
                        {selected?.uuid && (
                            <small className="text-muted">{selected.uuid}</small>
                        )}
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        {/* Customer Search Section */}
                        <Form.Group className="mb-4">
                            <Form.Label>Klant zoeken</Form.Label>
                            <InputGroup>
                                <Form.Control
                                    type="text"
                                    placeholder="Klantnummer of emailadres"
                                    value={searchValue}
                                    onChange={(e) => setSearchValue(e.target.value)}
                                    onKeyPress={(e) => e.key === 'Enter' && handleCustomerSearch()}
                                />
                                <Button 
                                    variant="outline-secondary" 
                                    onClick={handleCustomerSearch}
                                    disabled={searching || !searchValue.trim()}
                                    title="Klik om klant te zoeken"
                                >
                                    {searching ? (
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    ) : (
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
                                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                                        </svg>
                                    )}
                                </Button>
                            </InputGroup>
                        </Form.Group>

                        <hr className="mb-4" />

                        <Form.Group className="mb-3">
                            <Form.Label>Klantnummer</Form.Label>
                            <Form.Control
                                type="text"
                                name="customerId"
                                value={formData.customerId || ''}
                                onChange={handleInputChange}
                                disabled={true}
                                style={{ backgroundColor: '#f8f9fa' }}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Naam</Form.Label>
                            <Form.Control
                                type="text"
                                name="name"
                                value={formData.name || ''}
                                onChange={handleInputChange}
                                disabled={true}
                                style={{ backgroundColor: '#f8f9fa' }}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                type="email"
                                name="email"
                                value={formData.email || ''}
                                onChange={handleInputChange}
                                disabled={true}
                                style={{ backgroundColor: '#f8f9fa' }}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Testobjecten</Form.Label>
                            <Dropdown 
                                onSelect={(e) => e && e.preventDefault()}
                                autoClose={false}
                            >
                                <Dropdown.Toggle 
                                    variant="outline-secondary" 
                                    id="series-dropdown"
                                    className="w-100 text-start d-flex"
                                    disabled={seriesLoading}
                                >
                                    <span className="flex-grow-1">
                                        {seriesLoading ? 'Series laden...' : (
                                            formData.seriesEnabled && formData.seriesEnabled.length > 0 
                                                ? `${formData.seriesEnabled.length} series geselecteerd`
                                                : 'Selecteer series...'
                                        )}
                                    </span>
                                </Dropdown.Toggle>

                                <Dropdown.Menu className="w-100" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                    {(() => {
                                        const paidSeries = series.filter(s => s.isFree !== true);
                                        
                                        if (series.length === 0) {
                                            return <Dropdown.Item disabled>Geen series beschikbaar</Dropdown.Item>;
                                        } else if (paidSeries.length === 0) {
                                            return <Dropdown.Item disabled>Geen betaalde series beschikbaar</Dropdown.Item>;
                                        } else {
                                            return paidSeries.map((s) => {
                                                const isSelected = formData.seriesEnabled?.includes(s.uuid) || false;
                                                return (
                                                    <Dropdown.Item 
                                                        key={s.uuid} 
                                                        as="div" 
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            handleSeriesToggle(s.uuid, !isSelected);
                                                        }}
                                                        className="d-flex align-items-center"
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        <span 
                                                            style={{ 
                                                                width: '20px', 
                                                                textAlign: 'center', 
                                                                color: isSelected ? '#28a745' : 'transparent',
                                                                fontSize: '1.1rem',
                                                                marginRight: '8px'
                                                            }}
                                                        >
                                                            ✓
                                                        </span>
                                                        <span className="flex-grow-1">{s.name}</span>
                                                    </Dropdown.Item>
                                                );
                                            });
                                        }
                                    })()}
                                </Dropdown.Menu>
                            </Dropdown>
                            
                            {/* Display selected series */}
                            {formData.seriesEnabled && formData.seriesEnabled.length > 0 && (
                                <div className="mt-3">
                                    <Form.Label>Geselecteerde series:</Form.Label>
                                    <div className="d-flex flex-wrap gap-2">
                                        {formData.seriesEnabled.map((seriesUuid) => {
                                            const seriesItem = series.find(s => s.uuid === seriesUuid);
                                            return seriesItem ? (
                                                <span 
                                                    key={seriesUuid} 
                                                    className="badge"
                                                    style={{ 
                                                        fontSize: '0.8rem',
                                                        backgroundColor: 'var(--ukies-light-green)',
                                                        color: 'white',
                                                        padding: '0.5rem 0.75rem'
                                                    }}
                                                >
                                                    {seriesItem.name}
                                                </span>
                                            ) : null;
                                        })}
                                    </div>
                                </div>
                            )}
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-between align-items-center">
                    <div>
                        <Form.Switch
                            id="enabled-switch"
                            label={formData.enabled ? 'Test user actief' : 'Test user inactief'}
                            checked={formData.enabled}
                            onChange={handleEnabledToggle}
                            className={`custom-switch-large ${formData.enabled ? 'text-success' : 'text-danger'}`}
                            style={{ fontSize: '0.7rem !important' }}
                        />
                    </div>
                    <div className="d-flex align-items-center">
                        <Form.Switch
                            id="delete-enable-switch"
                            label=""
                            checked={deleteEnabled}
                            onChange={(e) => setDeleteEnabled(e.target.checked)}
                            className="me-2"
                            title="Schakel in om verwijderen toe te staan"
                            style={{ 
                                fontSize: '0.7rem',
                                display: 'flex',
                                alignItems: 'center',
                                marginBottom: '0'
                            }}
                        />
                        <Button 
                            variant="danger" 
                            onClick={handleDeleteTestUser}
                            disabled={!deleteEnabled || saving}
                            title="Test user permanent verwijderen"
                            style={{ marginRight: '3rem' }}
                        >
                            Verwijderen
                        </Button>
                        <Button variant="secondary" onClick={handleClose} className="me-2">
                            Annuleren
                        </Button>
                        <Button variant="primary" onClick={handleSave} disabled={saving}>
                            {saving ? 'Opslaan...' : 'Opslaan'}
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
} 